(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('siteAddAction', {
      controller: Controller,
      templateUrl: 'actions/site/add/add-site.action.html',
      bindings: {
        site: '<',
        then: '&',
        catch: '&'
      }
    });
}());
